import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { globalActions } from 'redux/global/global.slice';
import { RootState } from 'redux/store';

export function usePersonalizedLoading() {
    const dispatch = useDispatch();
    const spinnerLoading = useSelector((state: RootState) => state.global.spinnerLoading);
    const loadingHome = useSelector((state: RootState) => state.global.loadingHome);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        if (loadingHome) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            timerRef.current = setTimeout(() => {
                dispatch(globalActions.setSpinnerLoading(spinnerLoading.filter((item) => item !== 'loadingHome')));
                dispatch(globalActions.setLoadingHome(false));
            }, 1000);
        }
    }, [spinnerLoading, loadingHome, dispatch]);

    return spinnerLoading;
}
